import styled from "styled-components";

export const TextBoxStyles = styled.div`
    font-size: 1.2em;
    width: max-content;
    max-width: 50%;
    padding: 0.5em;
    height: auto;
    background-color: ${({type}) => 
        type === 'sent' ? '1px solid rgba(255, 255, 255, .25)': '#282c34'}; 
    color: ${({type}) => 
        type === 'sent' ? '#282c34': 'whitesmoke'};
    border: ${({type}) => 
    type === 'sent' ? '1px solid rgba(0, 0, 0, .25)': 'none'}; 
    border-radius: 2% 5% 2% 5%;
    margin: 3%;
    display: flex;
    flex-direction: column;
    align-self: ${({type}) => 
    type === 'sent' ? 'flex-end': 'flex-start'};

    pre{
        padding: 0;
        margin: 0;
    }

    span{
        height: 0.1em;
    }
`;